<template>
  <div class="media_manage_wrapper w100 h100">
    <!-- 筛选条件(无选中行时才显示) -->
    <a-row v-show="!selectedRowKeys.length" class="filter_row bcg_w">
      <div style="line-height: 32px">筛选：</div>
      <a-col :span="6">
        <a-select
          @change="
            () => {
              getTableData();
              getIndustryList();
            }
          "
          placeholder="请选择媒体"
          style="width: 90%"
          allow-clear
          v-model:value="filter.mediaChannel"
          :options="mediaOptions"
        >
        </a-select>
      </a-col>
      <a-col :span="6">
        <a-select @change="getTableData" placeholder="请选择行业" style="width: 90%" allow-clear v-model:value="filter.firstIndustryName" v-bind="$filterOptions">
          <a-select-option v-for="(item, index) in industryList" :key="index" :value="item.firstIndustryName" :label="item.firstIndustryName">{{ item.firstIndustryName }}</a-select-option>
        </a-select>
      </a-col>
      <div style="line-height: 32px">返点年份：</div>
      <a-col :span="6">
        <a-date-picker @change="getTableData" style="width: 100%" :allow-clear="false" :open="yearShowOne" @openChange="openChange" mode="year" v-model:value="filter.rebateYear" @panelChange="panelChangeOne" placeholder="请选择年份" value-format="YYYY" format="YYYY" />
      </a-col>
    </a-row>

    <!-- 媒体返点信息表格（双击返点信息可编辑） -->
    <div class="table_wrapper bcg_w">
      <!-- 保存行(有选中行时才显示) -->
      <a-row v-show="selectedRowKeys.length" class="save_row">
        <a-col :span="24">
          <a-space :size="20">
            <span>{{ `已选 ${selectedRowKeys.length} 条` }}</span>
            <a-input placeholder="请输入预估返点" v-model:value="rebate" type="number" suffix="%" style="padding: 0 5px; width: 240px"> </a-input>
            <a-button v-hasPermission="'MEDIAREBATE_EDIT'" @click="updateRebate" :loading="btnLoading" class="save_btn">保存</a-button>
            <a-button @click="selectedRowKeys = []" class="cancel_btn">取消</a-button>
            <span>点击保存后，所选行业的预计返点值将会更新！！！</span>
          </a-space>
        </a-col>
      </a-row>
      <a-table bordered :loading="tableLoading" size="small" :columns="columns" :data-source="tableData" :pagination="false" :scroll="{ y: 300 }" :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }">
        <template #mediaChannel="{ record }">
          {{ mediaChannel[record.mediaChannel] }}
        </template>
        <template #rebateRate="{ record }">
          <div
            class="edit_name"
            @dblclick="
              $event.target.setAttribute('contenteditable', true);
              $event.target.focus();
            "
            @blur="onBlur(record, $event)"
          >
            {{ record.rebateRate }}
          </div>
        </template>
      </a-table>
    </div>
    <!-- 编辑媒体与媒体详情 -->
  </div>
</template>

<script>
import moment from 'moment';
import { getMediaRebateList, saveMediaRebate, updateMediaRebate, deleteMediaRebate } from '@/api/mediaRebate';
export default {
  name: 'MediaManage',
  props: {},

  data() {
    const columns = [
      { title: '年份', dataIndex: 'rebateYear' },
      { title: '媒体名称', dataIndex: 'mediaChannel', slots: { customRender: 'mediaChannel' } },
      { title: '行业分类', dataIndex: 'firstIndustryName' },
      { title: '预估返点(%)', dataIndex: 'rebateRate', slots: { customRender: 'rebateRate' } },
    ];
    return {
      colSpan: '4',
      rebate: '',
      btnLoading: false,
      yearShowOne: false,
      tableLoading: false,
      columns,
      tableData: [],
      industryList: [],
      rowData: {},
      selectedRowKeys: [],
      selectedRows: [],
      currentComponent: 'add-media-rebate',
      filter: {
        mediaChannel: undefined,
        firstIndustryName: undefined,
        rebateYear: null,
      },
      // 媒体数据筛选配置
      mediaOptions: [
        { label: '巨量引擎', value: 'TT', key: 'TT' },
        { label: '腾讯广告', value: 'GDT', key: 'GDT' },
        { label: '磁力引擎', value: 'KS', key: 'KS' },
        { label: '巨量千川', value: 'QC', key: 'QC' },
      ],
      mediaChannel: { TT: '巨量引擎', GDT: '腾讯广告', KS: '磁力引擎' },
    };
  },
  async created() {
    // 得到表格数据
    this.filter.rebateYear = moment().format('YYYY');
    this.filter.rebateYear = moment(new Date().getFullYear() + '');
    await this.getTableData();
    // 获取行业下拉数据
    this.getIndustryList();
  },
  methods: {
    // 得到年份选择器的值
    panelChangeOne(value) {
      this.filter.rebateYear = value;
      this.yearShowOne = false;
      this.getTableData();
    },
    // 弹出日历和关闭日历的回调
    openChange(status) {
      this.yearShowOne = status;
    },
    // 获取行业下拉数据
    async getIndustryList() {
      const res = await getMediaRebateList({ mediaChannel: this.filter.mediaChannel });
      this.industryList = res.list;
    },
    // 获取表格数据
    async getTableData() {
      this.tableLoading = true;
      const data = { ...this.filter };
      data.rebateYear = data.rebateYear ? moment(data.rebateYear).format('YYYY') : '';
      const res = await getMediaRebateList(data);
      this.tableData = res.list.map(item => {
        item.key = this.$UUID.v1();
        return item;
      });
      setTimeout(() => {
        this.tableLoading = false;
      }, 500);
    },
    // 选中行变化
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    // 修改返点
    async updateRebate() {
      if (!this.rebate || this.rebate > 100) {
        this.$message.warning('返点值不能为空且应该不大于100!');
        return;
      }
      this.btnLoading = true;
      const editData = [];
      const addData = [];
      this.selectedRows.forEach(item => {
        item.rebateRate = this.rebate;
        item.rebateYear = item.rebateYear ? item.rebateYear + '' : moment(new Date().getFullYear() + '').format('YYYY');
        if (item.id) {
          editData.push(item);
        } else {
          delete item.id;
          addData.push(item);
        }
      });

      let res = {};
      if (editData.length) {
        res = await updateMediaRebate(editData);
        this.updateRow(res, editData);
      }
      if (addData.length) {
        res = await saveMediaRebate(addData);
        this.updateRow(res, addData);
      }
      this.btnLoading = false;
      this.rebate = '';
    },
    updateRow(res, data) {
      if (res.code === 0) {
        data.forEach(key => {
          this.tableData.find(item => {
            if (item.key === key) {
              item.rebateRate = this.rebate;
              return true;
            }
          });
        });
        this.selectedRowKeys = [];
      } else {
        this.$message.info('操作失败，请重试！');
      }
    },
    // 离开编辑框
    async onBlur(record, e) {
      e.target.setAttribute('contenteditable', false);
      if (e.target.innerText > 100) {
        e.target.innerText = record.rebateRate;
        this.$message.warning('返点值应该不大于100');
        return;
      }
      let rebateRate = e.target.innerText + '';
      const data = { ...record, rebateRate: rebateRate };
      data.rebateYear = data.rebateYear ? data.rebateYear + '' : moment(new Date().getFullYear() + '').format('YYYY');
      const res = await updateMediaRebate([data]);
      if (res.code === 0) {
        record.rebateRate = rebateRate;
      } else {
        this.$message.success('修改失败，请重试！');
        e.target.innerText = record.rebateRate;
      }
    },
  },
};
</script>

<style scoped lang="less">
.media_manage_wrapper {
  display: flex;
  flex-direction: column;
  @txtColor: #fff;
  .ant-row {
    &.save_row {
      padding: 8px 6px;
      background-color: #2f70f4;
      color: @txtColor;
      box-sizing: border-box;
      margin-bottom: 7px;
      border-radius: 8px;
      .ant-btn {
        color: @txtColor;
        border: 0;
        &.save_btn {
          background-color: #36c4bf;
        }
        &.cancel_btn {
          background-color: #8db7ee;
        }
      }
    }
    :deep(.ant-input) {
      height: 32px;
    }
  }

  .edit_name[contenteditable='true'] {
    outline: 1px solid #999;
  }
  :deep(.ant-table-wrapper) {
    height: calc(100% - 75px);
    .ant-table-body {
      max-height: calc(100vh - 195px) !important;
    }
  }
}
</style>
